import { Controller } from '@hotwired/stimulus'

/* stimulusFetch: 'eager' */
export default class extends Controller {
    static values = {
        maxSize: Number,
    }

    connect() {
        this.boundOnChange = this.onChange.bind(this)
        $(this.element).change(this.boundOnChange)
    }

    disconnect() {
        $(this.element).off('change', this.boundOnChange)
    }

    onChange() {
        const { files } = this.element
        const hasOverSizeFile = Array.from(files).some((file) => file.size > this.maxSizeValue)
        const widget = $(this.element).closest('label').parent()
        const formControl = widget.find('.form-control')
        widget.find('.invalid-feedback').remove()
        formControl.removeClass('is-invalid')
        if (hasOverSizeFile) {
            formControl.addClass('is-invalid')
            widget.append(
                `<div class="invalid-feedback d-block">The file is too large. Allowed maximum size is ${
                    this.maxSizeValue / 1000000
                } MB.</div>`
            )
        }
    }
}
